import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany, selectManager } from "../../homeSlice";
import {
  selectVehicleSessionsListStatus,
  vehicleSessionsAsync,
} from "../fleetSlice";
import { VehicleSessionDisplayed } from "../fleetApi";
import { SharedInterfaceVehicleSessions } from "./sharedInterface";
import { VehicleSessionSidePanel } from "./sidePanel/SidePanel";
import {
  getDepartmentsByCompanyAsync,
  selectGetDepartmentsByCompanyStatus,
} from "../../departments/departmentsSlice";

export const VehicleSessionsTab = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);
  const firstPath = location.pathname.split("/")[1]; // home or departments
  const vehicleSessionsListStatus = useAppSelector(
    selectVehicleSessionsListStatus,
  );
  const getDepartmentsByCompanyStatus = useAppSelector(
    selectGetDepartmentsByCompanyStatus,
  );

  useEffect(() => {
    if (company && vehicleSessionsListStatus === "idle") {
      void dispatch(vehicleSessionsAsync(company.uuid));
    }
  }, [company, dispatch, vehicleSessionsListStatus]);

  useEffect(() => {
    if (company && getDepartmentsByCompanyStatus === "idle") {
      void dispatch(getDepartmentsByCompanyAsync(company.uuid));
    }
  }, [company, dispatch, getDepartmentsByCompanyStatus]);

  const canUpdateRestitution = useMemo(
    () => manager?.role === "OWNER" || manager?.role === "ADMIN",
    [manager],
  );

  const sidePanelAction = useCallback(
    (row: Partial<VehicleSessionDisplayed> & { id?: string }) => {
      navigate(`/${firstPath}/fleet/vehicle_sessions/${row.id}`);
    },
    [navigate, firstPath],
  );

  if (params.tab !== "vehicle_sessions") {
    return;
  }

  return (
    <SharedInterfaceVehicleSessions
      sidePanelAction={sidePanelAction}
      sidePanel={(sidePanelProps) => (
        <VehicleSessionSidePanel
          sessionWithFinalRestitution={sidePanelProps.session}
          previousSessionId={sidePanelProps.previousSessionId}
          nextSessionId={sidePanelProps.nextSessionId}
          canUpdateRestitution={canUpdateRestitution}
        />
      )}
    />
  );
};
